export default __webpack_public_path__ + "static/media/debate_32.bd44d7cb.JPG";